export var MiscellaneousUserAgentsEnum;
(function (MiscellaneousUserAgentsEnum) {
    MiscellaneousUserAgentsEnum["ANDROID"] = "Android";
    MiscellaneousUserAgentsEnum["APPLE_WEBKIT"] = "AppleWebKit";
    MiscellaneousUserAgentsEnum["CHROME"] = "Chrome";
    MiscellaneousUserAgentsEnum["MOZILLA"] = "Mozilla/5.0";
    MiscellaneousUserAgentsEnum["IPHONE"] = "iPhone";
    MiscellaneousUserAgentsEnum["IPAD"] = "iPad";
    MiscellaneousUserAgentsEnum["MOBI"] = "mobi";
})(MiscellaneousUserAgentsEnum || (MiscellaneousUserAgentsEnum = {}));
//# sourceMappingURL=miscellaneous-user-agents.enum.js.map